import React from "react";
import Modal from "@mui/material/Modal";
import { useNavigate } from "react-router-dom";
import warningSign from "../../assets/warning-sign.png";

const WarningModal = ({ open, onClose, message, headerTitle }) => {
  const navigate = useNavigate();

  const handleOkayClick = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="limit-modal">
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#18103c",
          borderRadius: "22px",
          boxShadow: "0 4px 40px 0 rgba(0,0,0,0.6)",
          padding: "32px 24px 28px 24px",
          minWidth: 320,
          maxWidth: 400,
          width: "90vw",
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            borderRadius: 12,
            padding: 6,
            marginBottom: 14,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#20114c",
          }}
        >
          <img
            src={warningSign}
            alt="Warning"
            style={{
              width: 38,
              height: 38,
            }}
          />
        </div>

        <div
          style={{
            fontWeight: "700",
            fontSize: "19px",
            textAlign: "center",
            marginBottom: 10,
            marginTop: 4,
            fontFamily: "Roboto",
          }}
        >
          {headerTitle}
        </div>

        <div
          style={{
            borderRadius: 10,
            padding: "16px 10px",
            margin: "0 0 22px 0",
            textAlign: "center",
            background: "#18103c",
            fontWeight: "400",
            fontSize: "19px",
            color: "#CCCCCC",
            fontFamily: "Roboto",
          }}
        >
         {message}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            borderRadius: 12,
            padding: "10px 0",
            background: "#18103c",
          }}
        >
          <button
            onClick={handleOkayClick}
            style={{
              background: "linear-gradient(180deg, #9425C9 0%, #09055A 100%)",
              color: "#fff",
              fontWeight: "bold",
              border: "none",
              borderRadius: "16px",
              padding: "10px 36px",
              fontSize: "14px",
              cursor: "pointer",
              boxShadow: "0 2px 10px rgba(120,60,200,0.16)",
              fontFamily: "Roboto",
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default WarningModal;
